// src/hooks/useTaxasEntregaBairro.js
import { useCallback, useEffect, useRef, useState } from 'react';
import { useApi } from './useApi';
const SEM_TAXAS = [];

export const useTaxasEntregaBairro = (cidadeId, habilitado) => {
  const { fetchData } = useApi();
  const fetchRef = useRef(fetchData);
  fetchRef.current = fetchData;
  const requisicao = useRef(0);
  const [consultaAtual, setConsultaAtual] = useState(null);
  const [taxasEntregaBairro, setTaxasEntregaBairro] = useState([]);
  const [carregandoTaxasBairro, setCarregandoTaxasBairro] = useState(false);
  const [erroTaxasBairro, setErroTaxasBairro] = useState('');

  const carregarTaxasEntregaBairro = useCallback(async () => {
    const numero = ++requisicao.current;
    setConsultaAtual(cidadeId);
    setTaxasEntregaBairro([]);
    if (!habilitado || !cidadeId) {
      setCarregandoTaxasBairro(false);
      setTaxasEntregaBairro([]);
      setErroTaxasBairro('');
      return [];
    }

    setCarregandoTaxasBairro(true);
    setErroTaxasBairro('');

    try {
      const fetchData = fetchRef.current;
      const result = await fetchData('/TaxaEntregaBairroDelivery', { cidadeId });
      if (numero !== requisicao.current) return [];
      const taxas = Array.isArray(result) ? result : [];
      setTaxasEntregaBairro(taxas);
      return taxas;
    } catch (error) {
      if (numero !== requisicao.current) return [];
      console.error('Erro ao buscar taxas de entrega por bairro:', error);
      setTaxasEntregaBairro([]);
      setErroTaxasBairro('Não foi possível carregar os bairros. Tente novamente.');
      return [];
    } finally {
      if (numero === requisicao.current) setCarregandoTaxasBairro(false);
    }
    // O useApi cria uma nova função a cada renderização; cidade e configuração controlam a recarga.
  }, [cidadeId, habilitado]);

  useEffect(() => {
    carregarTaxasEntregaBairro();
    return () => { requisicao.current += 1; };
  }, [carregarTaxasEntregaBairro]);

  return {
    taxasEntregaBairro: habilitado && consultaAtual === cidadeId ? taxasEntregaBairro : SEM_TAXAS,
    carregandoTaxasBairro: !!(habilitado && cidadeId && (consultaAtual !== cidadeId || carregandoTaxasBairro)),
    erroTaxasBairro: habilitado && consultaAtual === cidadeId ? erroTaxasBairro : '',
    carregarTaxasEntregaBairro,
  };
};
